import { Flex, IconButton, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import { ReactComponent as ChevronLeftIcon } from 'resources/images/chevron-left.svg';

export const SettingsBackButton = () => {
  return (
    <Flex alignItems="center" gap={0}>
      <IconButton
        as={Link}
        to={routes.settings.path}
        variant="ghost"
        isRound
        h={9}
        minW={8}
        ml={-2}
        mr="-4px"
        color="M.70"
        icon={<ChevronLeftIcon height="16px" width="16px" />}
        aria-label="back button"
        sx={{
          boxShadow: 'unset !important',
          background: 'transparent !important',
          transform: 'unset !important',
        }}
      />
      <Text fontWeight={500} fontSize="sm">
        Settings
      </Text>
    </Flex>
  );
};
